import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLeveragedTokens = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M21.358 6.84a1.878 1.878 0 0 0-1.817-2.34 1.875 1.875 0 0 0-1.577 2.89L6.896 9.783a2.25 2.25 0 1 0-2.512.543l-.876.19a.75.75 0 0 0 .317 1.466l7.034-1.522-4.97 7.457c-.665.997.05 2.332 1.247 2.332h10.395c1.198 0 1.912-1.335 1.248-2.332l-5.197-7.796a1.524 1.524 0 0 0-.171-.213l7.748-1.676a.75.75 0 0 0 .2-1.392Zm-9.024 4.114 5.197 7.796H7.136l5.198-7.796Z"
    />
    <path fill="#F7A600" d="M11.667 15.75a.75.75 0 1 1 1.5 0v3h-1.5v-3Z" />
  </svg>
);
export default SvgTwoColorLeveragedTokens;
